// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1UCXr","content":"Consent_content__3auiZ","footer":"Consent_footer__2_7SY"};